<template>
  <div class="ecDeal">
    <banner clazz="ecDeal-banner" url="ecdeal">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        <el-button class="banner-button" round @click="goRegister('dianshancuohe-banner-tiyan')">申请体验</el-button>
      </template>
    </banner>
    <div class="ecDeal-section1">
      <div class="section1-content">
        <h1 class="section1-title">为SRM平台客户与供应商建立交易及撮合平台</h1>
        <div class="section1-divider"></div>
        <div class="ecDeal-intro">
          <p>甄云商城连接了多个外部采购平台（自有供应商和第三方电商平台），采购方通过一个商城平台，可获取海量商品选择，择优采购，实现企业采购集中化管理和一站式信息化采购流程。</p>
        </div>
        <div class="section1-photo">
          <img class="photo-img" src="../../assets/img/ecDeal/img.png" alt="为SRM平台客户与供应商建立交易及撮合平台"/>
        </div>
      </div>
    </div>

    <div class="ecDeal-section2">
      <div class="item-list">
        <div class="tc">
          <h1 class="item-list-title">甄云采购商城解决的难点</h1>
          <div class="dib tl border-bottom"></div>
        </div>
        <div class="item-tab">
          <el-tabs type="border-card" class="ecDeal-tab">
            <el-tab-pane label="非生产物资的管控难点">
              <div class="rel clearfix content">
                <div class="fl rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/ecDeal/nandian1.png" alt="非生产物资的管控难点">
                  </div>
                  <div class="abs right-bg rbg01"></div>
                </div>
                <div class="fl left-list">
                  <div class="left-desc">
                    <div class="contents-detail">
                      <span class="detail-bar"></span>采购成本高：价格不透明，缺乏竞争机制，采购相关费用高
                    </div>
                    <div class="contents-detail">
                      <span class="detail-bar"></span>采购质量差：缺乏统一的供应商评价体系以及定期审查、年审
                    </div>
                    <div class="contents-detail">
                      <span class="detail-bar"></span>采购协同弱：缺乏有效的企业内外部协同支撑，无法降低整体成本，影响效率
                    </div>
                    <div class="contents-detail">
                      <span class="detail-bar"></span>采购管控散：原有的采购分散，由于缺乏工具支撑无法整合形成规模化采购
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="甄云解决方案">
              <div class="rel clearfix content">
                <div class="fl rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/ecDeal/nandian2.png" alt="甄云解决方案">
                  </div>
                  <div class="abs right-bg rbg01"></div>
                </div>
                <div class="fl left-list">
                  <h1 class="title">甄云采购商城整合间接物资海量供应商， 对接内部系统，给企业带来非常可观的价值。</h1>
                  <div class="left-desc">
                    <div class="contents-detail">
                      <span class="detail-bar"></span>降低成本：战略寻源，集合海量货源，通过比价，招投标降低采购成本
                    </div>
                    <div class="contents-detail">
                      <span class="detail-bar"></span>提高效率：建立统一集成的供应商管理管理系统提升内外部效率
                    </div>
                    <div class="contents-detail">
                      <span class="detail-bar"></span>保证质量：建立供应商全生命周期管理体系，优胜劣汰
                    </div>
                    <div class="contents-detail">
                      <span class="detail-bar"></span>控制风险：通过IT手段，规范采购业务流程，降低采购风险
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <div class="ecDeal-section3">
      <div class="section3-content">
        <h1 class="section3-title">为什么选择甄云采购商城？</h1>
        <div class="section3-divider"></div>
        <div class="ecDeal-intro">
          <p>从客户需求出发，结合数字化技术，简化企业采购流程，提供高质海量供应货源</p>
        </div>
        <div class="section3-photo clealfix">
          <div class="photo-div" v-for="(item, index) in sectionData" :key="item.id"
               :style="{'backgroundImage': 'url(' + require('../../assets/img/ecDeal/peitu-' + (index + 1) +'.png') + ')'}">
            <div class="photo-div-icon">
              <img v-lazy="$global.globalPath + item.imgtag" alt="为什么选择甄云采购商城">
            </div>
            <h2 class="photo-div-title">{{item.title}}</h2>
            <div class="photo-div-con tl">
              <p>{{item.describe}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ecDeal-section4">
      <div class="section4-content">
        <h1 class="section4-title">成功客户案例</h1>
        <div class="section4-divider"></div>
        <div class="section4-photo clearfix">
          <div class="section4-photo-div" v-for="item in imgData"
               :key="item.id">
            <img v-lazy="$global.globalPath + item.dians_logo" alt="成功客户案例"/>
          </div>
        </div>
        <hover-button clazz="consult-button" text="获取案例详情" @click.native="goMoreCase"></hover-button>
      </div>
    </div>
  </div>
</template>

<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'EcDeal',
  metaInfo () {
    return {
      title: this.$seo.ecdeal.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.ecdeal.keywords
      },
      {
        name: 'description',
        content: this.$seo.ecdeal.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      sectionData: [],
      imgData: []
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    },
    // 案例详情
    goMoreCase () {
      let routeObj = this.$router.resolve({ path: '/clientele' })
      window.open(routeObj.href, '_blank')
    },
    getSection () {
      this.$api.post('/suite/get_mall', {}, (r) => {
        if (r.code === 0) {
          this.sectionData = r.data
        } else {
          this.$message.error(r.msg)
        }
      })
    },
    getImgData () {
      let form = {
        webname: 'ecDeal',
        cases_num: 10
      }
      this.$api.post('cases/get_cases', form, (r) => {
        if (r.code === 0) {
          this.imgData = r.data
        } else {
          this.$message.error(r.msg)
        }
      })
    }
  },
  created () {
    this.getSection()
    this.getImgData()
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/ecDeal.scss";
</style>



// WEBPACK FOOTER //
// ecDeal.vue?0ee2bf42